import OpenItem, { RemedyLink } from './OpenItem.jsx';
import { NOTHING_WAITING, NO_DOOR_HERE, AIRGUS_NOT_RUN, AIRGUS_FAILED } from './words.js';

// THE NEXT-THING LINE on top of the account page: airgus.next_thing as the
// service said it (message plus its remedy), or NOTHING_WAITING when AIRgus
// answered with no next thing; AIRGUS_NOT_RUN or AIRGUS_FAILED when it did not.
// Under it, "Also open": every item that has no fact_ref and so no row of its
// own to sit on. Items WITH a fact_ref render on their row, not here. The
// next thing is not repeated in the list.

export default function NextThing({ airgus, loose = [], remedyHref }) {
  const next = airgus?.next_thing || null;
  const also = loose.filter((it) => !(next && it.code === next.code && it.subject?.id === next.subject?.id));
  const counts = airgus?.counts || null;
  // Only a derivation that answered may say nothing is waiting (words.js AIRGUS_NOT_RUN / AIRGUS_FAILED).
  const airgusState = airgus == null ? 'not_run' : airgus.ok === false ? 'failed' : 'answered';
  const silent = airgusState === 'not_run' ? AIRGUS_NOT_RUN : airgusState === 'failed' ? AIRGUS_FAILED : null;
  return (
    <section className="rounded-card border border-border bg-surface px-4 py-3" data-next-thing>
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-text-dim">Next</span>
        {next ? (
          <>
            <span className="min-w-0 basis-full text-[15px] font-medium text-text sm:flex-1 sm:basis-auto" data-next-message>{next.message}</span>
            {next.remedy ? (
              remedyHref?.(next) ? (
                <RemedyLink href={remedyHref(next)} opener={next.remedy.opener} className="inline-flex min-h-[40px] items-center rounded-card bg-accent px-3 text-sm font-medium text-white hover:bg-accent/90" data-next-remedy>{next.remedy.label}</RemedyLink>
              ) : (
                <span className="text-sm text-text-dim" data-next-remedy data-no-door>{next.remedy.label}: {NO_DOOR_HERE}</span>
              )
            ) : null}
          </>
        ) : (
          <span className={`text-[15px] ${silent ? 'text-warning' : 'text-text-muted'}`} data-next-message data-airgus-state={airgusState}>{silent || NOTHING_WAITING}</span>
        )}
        {counts ? <span className="basis-full font-mono text-[11px] text-text-dim sm:basis-auto sm:ml-auto">{counts.blocker} blocking · {counts.warning} attention · {counts.info} notes{counts.unknown ? ` · ${counts.unknown} unknown` : ''}</span> : null}
      </div>
      {also.length ? (
        <div className="mt-2 border-t border-border pt-1" data-also-open>
          <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-text-dim">Also open ({also.length})</div>
          {also.map((it, i) => <OpenItem key={it.code + i} item={it} href={remedyHref?.(it)} />)}
        </div>
      ) : null}
    </section>
  );
}
